<div class="default-dialog-wrapper mat-elevation-z10">
    <div class="flex flex-col content">
        <div class="flex flex-col">
        <div class="flex flex-row justify-end w-100-percent">
            <mat-icon svgIcon="timer" class="w-48 h-48 items-center mr-200 timer-color"></mat-icon>
        </div>
        </div>
        <div class="flex flex-col mt-12 items-center">
            <h1 class="flex flex-wrap basis-full mat-headline-5 mb-14 fw-600">{{title}}</h1>
            <div class="mat-subtitle-2 fw-400 message" [innerHtml]="messageInactive"></div>
            <div class="mat-subtitle-2 fw-400 mb-24 message" [innerHtml]="messageSecurity"></div>
            <div class="flex flex-row justify-center w-100-percent">
            <button class="white mr-12" [matDialogClose]="false" (click)="logOut()">{{'DIALOG.LOGOUT'| transloco}}</button>
            <button class="accent" [matDialogClose]="true" (click)="reset()">{{confirmButtonText}}</button>
            </div>
        </div>
    </div>
  </div>